// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"a2cad2aae49f65b2b03b","293":"59b11bd3648e50a4994c","518":"5f4c346ca0000fee8eb6","779":"669e290088f3140d8db6"}[chunkId] + ".js";
};